/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Cancellation entity<br />
 * To be added if booking is cancelled
 * @export
 * @interface TravelineBookingCancellationDto
 */
export interface TravelineBookingCancellationDto {
    /**
     * Penalty amount for cancellation
     * @type {number}
     * @memberof TravelineBookingCancellationDto
     */
    penaltyAmount?: number | null;
    /**
     * Cancellation reason
     * @type {string}
     * @memberof TravelineBookingCancellationDto
     */
    reason?: string | null;
    /**
     * Cancellation time in UTC. Format complies with ISO-8601 YYYY-MM-DDThh:mm:ss
     * @type {Date}
     * @memberof TravelineBookingCancellationDto
     */
    cancelledUtc: Date;
}

/**
 * Check if a given object implements the TravelineBookingCancellationDto interface.
 */
export function instanceOfTravelineBookingCancellationDto(value: object): value is TravelineBookingCancellationDto {
    if (!('cancelledUtc' in value) || value['cancelledUtc'] === undefined) return false;
    return true;
}

export function TravelineBookingCancellationDtoFromJSON(json: any): TravelineBookingCancellationDto {
    return TravelineBookingCancellationDtoFromJSONTyped(json, false);
}

export function TravelineBookingCancellationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingCancellationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'penaltyAmount': json['penaltyAmount'] == null ? undefined : json['penaltyAmount'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'cancelledUtc': (new Date(json['cancelledUtc'])),
    };
}

  export function TravelineBookingCancellationDtoToJSON(json: any): TravelineBookingCancellationDto {
      return TravelineBookingCancellationDtoToJSONTyped(json, false);
  }

  export function TravelineBookingCancellationDtoToJSONTyped(value?: TravelineBookingCancellationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'penaltyAmount': value['penaltyAmount'],
        'reason': value['reason'],
        'cancelledUtc': ((value['cancelledUtc']).toISOString()),
    };
}

